import {
  faDesktop,
  faFlask,
  faFlaskVial,
  faHouseMedical,
  faKitMedical,
  faSignalStream,
  faSyringe,
  faUserMd,
  faWavePulse,
} from '@fortawesome/pro-light-svg-icons';
import type { IconDefinition } from '@fortawesome/pro-light-svg-icons';

import { SearchResult } from '@/app/(main)/_components/search-modal/search-modal.types';
import { SearchType } from '@/types/most-search-type';

const TITLE_MAP: Record<string, string> = {
  PRESENTIAL_CONSULTATION: 'Atendimento presencial',
  ONLINE_CONSULTATION: 'Teleconsulta',
  IMAGE_EXAM: 'Exame de imagem',
  EMERGENCY: 'Pronto atendimento',
  SURGERY: 'Cirurgia',
};

export function resolveTitle(searchResult: SearchResult, inRecentSearch = false): string {
  if (searchResult.searchType && TITLE_MAP[searchResult.searchType]) {
    return TITLE_MAP[searchResult.searchType];
  }

  if (searchResult.searchType === SearchType.LABORATORIAL_EXAM) {
    if (!inRecentSearch) {
      return 'Exame laboratorial';
    }
    const parts = ['Exame laboratorial', `${searchResult.id?.split(',').length} exames`].filter(Boolean);
    return parts.join(' · ');
  }

  if (searchResult.searchType === SearchType.VACCINE) {
    if (!inRecentSearch) {
      return 'Vacina';
    }
    const parts = ['Vacina', `${searchResult.id?.split(',').length} Vacinas`].filter(Boolean);
    return parts.join(' · ');
  }

  if (searchResult.searchType === SearchType.DOCTOR) {
    const specialties = searchResult?.specialties?.slice(0, 2).join(', ');
    return ['Profissional', specialties].join(' - ');
  }

  if (searchResult.searchType === SearchType.CLINIC) {
    return ['Local de atendimento', searchResult.city, searchResult.state].join(' - ');
  }

  if (searchResult.searchType === SearchType.BRANCH_LABORATORY) {
    return ['Laboratório', searchResult.city, searchResult.state].join(' - ');
  }

  return '';
}

const ICON_MAP: Record<string, IconDefinition> = {
  PRESENTIAL_CONSULTATION: faUserMd,
  ONLINE_CONSULTATION: faDesktop,
  LABORATORIAL_EXAM: faFlask,
  IMAGE_EXAM: faSignalStream,
  EMERGENCY: faKitMedical,
  VACCINE: faSyringe,
  SURGERY: faWavePulse,
  CLINIC: faHouseMedical,
  BRANCH_LABORATORY: faFlaskVial,
  DOCTOR: faUserMd,
};

export function resolveIcon(searchResult: SearchResult): IconDefinition {
  if (searchResult.searchType && ICON_MAP[searchResult.searchType]) {
    return ICON_MAP[searchResult.searchType];
  }
  return faUserMd;
}
